import { render } from "./Articles-tab-page.vue?vue&type=template&id=3f008a4a&scoped=true"
import script from "./Articles-tab-page.vue?vue&type=script&lang=js"
export * from "./Articles-tab-page.vue?vue&type=script&lang=js"

import "./Articles-tab-page.vue?vue&type=style&index=0&id=3f008a4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f008a4a"]])

export default __exports__